import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
import AprActivitiesRepository from '@/shared/http/repositories/business/aprActivities'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'templateFilter',
  components: {Multiselect},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      form: {
        activities: null,
        typeRisk: null,
        natureRisk: null,
        consequencesActions: null
      },
      forms: {
        listagemInterna: [],
        descricao: null
      },
      lista: [],
      listAtividades: {
        nome: 'ATIVIDADES',
        categoria: 0,
        list: []
      },
      listTipoRisco: {
        nome: 'TIPOS DE RISCOS',
        categoria: 1,
        list: []
      },
      listCausa: {
        nome: 'CAUSA OU NATUREZA DO RISCO',
        categoria: 2,
        list: []
      },
      listConsequencias: {
        nome: 'CONSEQUÊNCIAS',
        categoria: 3,
        list: []
      },
      listRiscoEspeciais: {
        nome: 'RISCOS ESPECIAIS',
        categoria: 4,
        list: []
      },
      listCursoNR: {
        nome: 'CURSOS NR',
        categoria: 5,
        list: []
      },
      listEPI: {
        nome: 'EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL',
        categoria: 6,
        list: []
      },
      listFonteGeradora: {
        nome: 'MEDIDAS DE CONTROLE/MITIGADORAS',
        categoria: 7,
        list: []
      },
      listMedidasControle: {
        nome: 'FONTE GERADORA',
        categoria: 8,
        list: []
      },
      listDescricaoAtividade: {
        nome: 'DESCRIÇÃO ATIVIDADE',
        categoria: 9,
        list: []
      },
      listFerramentas: {
        nome: 'FERRAMENTAS',
        categoria: 10,
        list: []
      },
      listagem: [],
      listagemInterna: []
    }
  },
  mounted () {
    this.getAllCategories()
  },
  methods: {
    Search () {
      this.$emit('search', {
        Listagem: this.forms.listagemInterna,
        Descricao: this.forms.descricao
      })
    },
    onClearSection () {
      this.forms.listagemInterna = null
      this.forms.descricao = null
    },
    getAllCategories () {
      this.getAllActivities()
      this.getAllTypeRisks()
      this.getAllReason()
      this.getAllConsequences()
      this.getAllSpecialRisks()
      this.getAllCourseNR()
      this.getAllEquipamentoProtecaoIndividual()
      this.getAllMedidasControle()
      this.getAllFonteGeradora()
      this.getAllDescricaoAtividade()
      this.getAllFerramentas()
      if (this.listagem.length !== 0) {
        this.listagem = []
      }
      this.listagem.push(
        this.listAtividades,
        this.listTipoRisco,
        this.listCausa,
        this.listConsequencias,
        this.listRiscoEspeciais,
        this.listCursoNR,
        this.listEPI,
        this.listFonteGeradora,
        this.listMedidasControle,
        this.listDescricaoAtividade,
        this.listFerramentas
      )
    },
    getAllActivities () {
      AprActivitiesRepository.GetAllActivities()
        .then(Response => {
          this.listAtividades.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllTypeRisks () {
      AprActivitiesRepository.GetAllTypeRisks()
        .then(Response => {
          this.listTipoRisco.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllReason () {
      AprActivitiesRepository.GetAllReasons()
        .then(Response => {
          this.listCausa.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllConsequences () {
      AprActivitiesRepository.GetAllConsequences()
        .then(Response => {
          this.listConsequencias.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllSpecialRisks () {
      AprActivitiesRepository.GetAllSpecialRisks()
        .then(Response => {
          this.listRiscoEspeciais.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllCourseNR () {
      AprActivitiesRepository.GetAllCourseNR()
        .then(Response => {
          this.listCursoNR.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllEquipamentoProtecaoIndividual () {
      AprActivitiesRepository.GetAllEquipamentoProtecaoIndividual()
        .then(Response => {
          this.listEPI.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllMedidasControle () {
      AprActivitiesRepository.GetAllMedidasControle()
        .then(Response => {
          this.listMedidaControle.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllFonteGeradora () {
      AprActivitiesRepository.GetAllFonteGeradora()
        .then(Response => {
          this.listFonteGeradora.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllDescricaoAtividade () {
      AprActivitiesRepository.GetAllDescricaoAtividade()
        .then(Response => {
          this.listDescricaoAtividade.list = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllFerramentas () {
      AprActivitiesRepository.GetAllFerramentas()
        .then(Response => {
          this.listFerramentas.list = Response.data.data
        })
        .catch(Error => loading.pop())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/registerApr/components/registerFilter/registerFilter.js